/* ===============================================================
   ECアカデミー 出展者募集LP — フォームモーダル + 送信ロジック
   assets/ecacademy-exhibitor-form.js
   =============================================================== */
(function () {
  'use strict';

  var HUBSPOT_PORTAL_ID = '20009205';
  var HUBSPOT_FORM_ID   = 'c1479f6b-be75-411d-b3e5-3eeb63bb7063';
  var HUBSPOT_ENDPOINT  = 'https://api-na2.hsforms.com/submissions/v3/integration/submit/' + HUBSPOT_PORTAL_ID + '/' + HUBSPOT_FORM_ID;
  var N8N_WEBHOOK_URL   = 'https://ops.for-people.co.jp/webhook/eca-exhibitor-lp-post-submission';
  var THANKS_URL        = '/pages/ecacademy-exhibitor-thanks';
  var SUBMIT_TIMEOUT_MS = 10000;

  var WEEKDAY = ['日', '月', '火', '水', '木', '金', '土'];

  /* ---- UTMパラメータ取得 ---- */
  function getUtmParams() {
    var params = {};
    var search = window.location.search;
    if (!search) return params;
    var pairs = search.slice(1).split('&');
    pairs.forEach(function (pair) {
      var kv = pair.split('=');
      var key = decodeURIComponent(kv[0] || '');
      if (key === 'utm_source' || key === 'utm_medium' || key === 'utm_campaign') {
        params[key] = decodeURIComponent(kv[1] || '');
      }
    });
    return params;
  }

  /* ---- データ変換 ---- */
  function splitFullName(fullname) {
    var trimmed = (fullname || '').trim();
    var match = trimmed.match(/^(\S+)[\s\u3000]+(.+)$/);
    if (match) {
      return { lastname: match[1], firstname: match[2].trim() };
    }
    return { lastname: trimmed, firstname: '' };
  }

  function formatDateTime(dateValue, timeValue) {
    if (!dateValue || !timeValue) return '';
    var parts = dateValue.split('-').map(Number);
    var year = parts[0], month = parts[1], day = parts[2];
    var weekday = WEEKDAY[new Date(year, month - 1, day).getDay()];
    var yyyy = String(year).padStart(4, '0');
    var mm   = String(month).padStart(2, '0');
    var dd   = String(day).padStart(2, '0');
    return yyyy + '/' + mm + '/' + dd + '(' + weekday + ') ' + timeValue + '〜';
  }

  /* ---- GTMイベント ---- */
  function pushDataLayer(eventName, label) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: eventName };
    if (label) payload.label = label;
    window.dataLayer.push(payload);
  }

  /* ---- Fetch with AbortController ---- */
  function fetchWithTimeout(url, options, timeoutMs) {
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, timeoutMs);
    return fetch(url, Object.assign({}, options, { signal: controller.signal }))
      .finally(function () { clearTimeout(timer); });
  }

  /* ---- モーダル管理 ---- */
  function initModal() {
    var modal        = document.getElementById('exhibitor-form-modal');
    var triggers     = document.querySelectorAll('[data-form-trigger]');
    var closeButtons = document.querySelectorAll('[data-form-close]');
    if (!modal) return;

    var lastFocused = null;

    function openModal(triggerEl) {
      lastFocused = triggerEl || document.activeElement;
      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
        modal.style.display = 'flex';
      }
      document.body.style.overflow = 'hidden';
      var firstInput = modal.querySelector('.form-modal__body input, .form-modal__body select, .form-modal__body textarea');
      if (firstInput) firstInput.focus();
    }

    function closeModal() {
      if (typeof modal.close === 'function') {
        modal.close();
      } else {
        modal.removeAttribute('open');
        modal.style.display = '';
      }
      document.body.style.overflow = '';
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    triggers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var label = btn.getAttribute('data-cta-label') || 'unknown';
        pushDataLayer('cta_click', label);
        openModal(btn);
      });
    });

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });

    modal.addEventListener('close', function () {
      document.body.style.overflow = '';
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    });

    /* フォーカストラップ */
    modal.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusable = modal.querySelectorAll(
        'input:not([disabled]), textarea:not([disabled]), button:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last  = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  /* ---- フォーム送信 ---- */
  function initForm() {
    var form     = document.getElementById('exhibitor-form');
    var errorBox = document.getElementById('form-error');
    var submitBtn = form ? form.querySelector('[type="submit"]') : null;
    if (!form || !errorBox || !submitBtn) return;

    var DEFAULT_ERROR_MSG = errorBox.textContent;

    function showError(msg) {
      errorBox.textContent = msg || DEFAULT_ERROR_MSG;
      errorBox.classList.add('is-visible');
    }

    function clearError() {
      errorBox.textContent = DEFAULT_ERROR_MSG;
      errorBox.classList.remove('is-visible');
    }

    function setSubmitting(flag) {
      submitBtn.disabled = flag;
      submitBtn.setAttribute('aria-busy', String(flag));
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      clearError();

      /* クライアントバリデーション */
      if (!form.checkValidity()) {
        showError('入力内容にエラーがあります。各項目をご確認ください。');
        var firstInvalid = form.querySelector(':invalid');
        if (firstInvalid) firstInvalid.focus();
        return;
      }

      /* お名前 スペース区切りチェック */
      var fullnameVal = (form.querySelector('[name="fullname"]').value || '').trim();
      if (!/[\s　]/.test(fullnameVal)) {
        showError('お名前は姓と名の間に半角または全角スペースを入れてご入力ください。例: 山田 太郎');
        form.querySelector('[name="fullname"]').focus();
        return;
      }

      /* 第二希望 部分入力チェック */
      var date2 = form.querySelector('[name="date_2"]').value;
      var time2 = form.querySelector('[name="time_2"]').value;
      if ((date2 && !time2) || (!date2 && time2)) {
        showError('ご希望日時（第二希望）は、日付と時刻の両方をご入力ください（両方未入力の場合は送信できます）。');
        var target = !date2 ? form.querySelector('[name="date_2"]') : form.querySelector('[name="time_2"]');
        if (target) target.focus();
        return;
      }

      /* テーマプレビュー時は実送信を止める */
      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        alert('[開発モード] フォーム送信をスキップしました（Shopify designMode）');
        return;
      }

      setSubmitting(true);

      /* データ変換 */
      var formData    = new FormData(form);
      var name        = splitFullName(formData.get('fullname'));
      var datetime1   = formatDateTime(formData.get('date_1'), formData.get('time_1'));
      var datetime2   = formatDateTime(formData.get('date_2'), formData.get('time_2'));
      var utmParams   = getUtmParams();

      var hubspotPayload = {
        fields: [
          { name: 'lastname',    value: name.lastname },
          { name: 'firstname',   value: name.firstname },
          { name: 'company',     value: formData.get('company') || '' },
          { name: 'email',       value: formData.get('email') || '' },
          { name: 'phone',       value: formData.get('phone') || '' },
          { name: 'exhibitor_briefing_preferred_datetime_1', value: datetime1 },
          { name: 'exhibitor_briefing_preferred_datetime_2', value: datetime2 },
          { name: 'exhibitor_briefing_question', value: formData.get('exhibitor_briefing_question') || '' }
        ],
        context: {
          pageUri: window.location.href,
          pageName: document.title
        }
      };

      /* (1) HubSpot送信 */
      fetchWithTimeout(HUBSPOT_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(hubspotPayload)
      }, SUBMIT_TIMEOUT_MS)
        .then(function (res) {
          if (!res.ok) {
            return res.json().catch(function () { return {}; }).then(function (body) {
              throw new Error('HubSpot error: ' + res.status + ' ' + JSON.stringify(body));
            });
          }
          return res.json();
        })
        .then(function (data) {
          pushDataLayer('form_submit_success');

          /* (2) n8n webhook 直列POST */
          var n8nPayload = {
            source_lp: 'ecacademy-exhibitor',
            lastname:  name.lastname,
            firstname: name.firstname,
            company:   formData.get('company') || '',
            email:     formData.get('email') || '',
            phone:     formData.get('phone') || '',
            exhibitor_briefing_preferred_datetime_1: datetime1,
            exhibitor_briefing_preferred_datetime_2: datetime2,
            exhibitor_briefing_question: formData.get('exhibitor_briefing_question') || '',
            utm_source:   utmParams.utm_source   || '',
            utm_medium:   utmParams.utm_medium   || '',
            utm_campaign: utmParams.utm_campaign || ''
          };

          if (N8N_WEBHOOK_URL) {
            return fetchWithTimeout(N8N_WEBHOOK_URL, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(n8nPayload)
            }, SUBMIT_TIMEOUT_MS).catch(function () {
              /* n8nが失敗してもサンクスページへ遷移（HubSpotには記録済み） */
            });
          }
        })
        .then(function () {
          window.location.href = THANKS_URL;
        })
        .catch(function (err) {
          setSubmitting(false);
          pushDataLayer('form_submit_error');
          showError('送信中にエラーが発生しました。しばらくしてから再度お試しください。');
          console.error('[exhibitor-form]', err);
        });
    });
  }

  /* ---- FAQアコーディオン ---- */
  function initFaq() {
    document.querySelectorAll('.ex-faq__question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.ex-faq__item');
        if (!item) return;
        var isClosed = item.classList.contains('is-closed');
        item.classList.toggle('is-closed', !isClosed);
        btn.setAttribute('aria-expanded', String(isClosed));
      });
    });
  }

  /* ---- 出展者スライダー ---- */
  function initExhibitorsSlider() {
    document.querySelectorAll('[data-ex-exhibitors-slider]').forEach(function (outer) {
      var viewport = outer.querySelector('.ex-exhibitors__slider-viewport');
      var track    = outer.querySelector('.ex-exhibitors__slider-track');
      var prevBtn  = outer.querySelector('.ex-exhibitors__slider-btn--prev');
      var nextBtn  = outer.querySelector('.ex-exhibitors__slider-btn--next');
      var cards       = track ? Array.prototype.slice.call(track.querySelectorAll('.ex-exhibitors__card')) : [];
      var progressBar = outer.parentElement.querySelector('.ex-exhibitors__progress-bar');

      if (!viewport || !track || cards.length === 0) return;

      var currentIndex = 0;

      if (progressBar) {
        progressBar.style.width = (100 / cards.length) + '%';
      }

      function getGap() {
        return parseFloat(window.getComputedStyle(track).columnGap) || 0;
      }

      function getCardWidth() {
        return cards[0].offsetWidth + getGap();
      }

      function getMaxIndex() {
        var overflow = track.scrollWidth - viewport.offsetWidth;
        if (overflow <= 0) return 0;
        return Math.ceil(overflow / getCardWidth());
      }

      function updateButtons() {
        var max = getMaxIndex();
        if (prevBtn) prevBtn.disabled = currentIndex <= 0;
        if (nextBtn) nextBtn.disabled = currentIndex >= max;
      }

      function updateProgress() {
        if (!progressBar) return;
        var max = getMaxIndex();
        var pct = max > 0 ? (currentIndex / max) * (cards.length - 1) * 100 : 0;
        progressBar.style.transform = 'translateX(' + pct + '%)';
      }

      function goTo(index) {
        currentIndex = Math.max(0, Math.min(index, getMaxIndex()));
        track.style.transform = 'translateX(-' + (currentIndex * getCardWidth()) + 'px)';
        updateButtons();
        updateProgress();
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex + 1); });

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          goTo(Math.min(currentIndex, getMaxIndex()));
        }, 200);
      });

      updateButtons();
    });
  }

  /* ---- 初期化 ---- */
  function init() {
    initModal();
    initForm();
    initFaq();
    initExhibitorsSlider();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
